{
  "it": {
    "document": {
      "actions": {
        "clear_selection": "Svuota selezione",
        "delete": "Elimina",
        "deleteMultipleDocuments": "Elimina",
        "delete_cancel": "Annulla",
        "delete_documents": "Elimina documento | Elimina documenti",
        "delete_documents_upload": "Rimuovi {count} documento | Rimuovi {count} documenti",
        "download": "Scarica",
        "edit": "Modifica",
        "edit_category": "Modifica categoria",
        "groupByCategory": "Attiva/disattiva raggruppamento per categoria",
        "hideDetails": "Nascondi dettagli",
        "hide_for_project_partners": "Nascondi per i partner del progetto",
        "new": "Documenti",
        "new_customer": "Aggiungi documenti",
        "reset_filters": "Reimposta filtri",
        "select_all": "Seleziona tutti i {total} documenti",
        "share": "Condividi",
        "shareCustomer": "Condividi con il cliente",
        "shareCustomerPartners": "Condividi con il cliente e i partner del progetto",
        "share_documents": "Condividi documento | Condividi documenti",
        "share_with": "Condividi con...",
        "share_with_project_partners": "Condividi con i partner del progetto",
        "showDetails": "Mostra dettagli",
        "submit": "Salva",
        "tickBoxesDeletion": "Selezioni le caselle dei file che desidera eliminare.",
        "unshare": "Rimuovi condivisione",
        "unshare_documents": "Rimuovi condivisione documento | Rimuovi condivisione documenti"
      },
      "attachable_types": {
        "building": "Edificio",
        "decisions": "Decisioni",
        "installment": "Rata",
        "issue": "Segnalazione",
        "lot": "Lotto",
        "phase": "Fase",
        "project": "Progetto",
        "tickets": "Conversazioni",
        "unit": "Unità"
      },
      "attributes": {
        "category": "Categoria",
        "file_ext": "Tipo di file",
        "file_size": "Dimensione del file",
        "name": "Nome",
        "size": "Dimensione",
        "type": "Tipo",
        "uploaded_at": "Caricato il",
        "uploaded_by": "Caricato da"
      },
      "category": {
        "admin": "Amministrazione",
        "aftercare": "Post-vendita",
        "as_built": "Fascicolo del fabbricato",
        "brochure": "Brochure",
        "conversation": "Conversazione",
        "decision": "Decisione",
        "image": "Immagine",
        "invoice": "Fattura",
        "legal": "Legale",
        "manual": "Manuale",
        "other": "Altro",
        "plan": "Planimetria",
        "quote": "Preventivo",
        "ticket": "Conversazione"
      },
      "labels": {
        "actions": "Azioni",
        "allDocuments": "Tutti i documenti",
        "allUnits": "Tutte le unità",
        "backToCategories": "Categorie",
        "building": "edificio",
        "categories": "Categorie",
        "category": "Categoria",
        "changeCategory": "Cambia categoria in:",
        "changeFilterOrStartUploading": "Cambia filtro o carica un nuovo documento",
        "created": "Creato",
        "customer": "Cliente",
        "decision": "decisione",
        "decisionsAndProposals": "Decisioni e proposte",
        "delete_documents": "È sicuro di voler eliminare questo documento? Questa azione non può essere annullata. | È sicuro di voler eliminare questi documenti? Questa azione non può essere annullata.",
        "disclaimerDocumentsCustomer": "Trovi o carichi i documenti relativi alla decisione {decision_name}",
        "documents": "Documenti",
        "documents_all": "Tutti i documenti",
        "documents_all_projects": "Documenti di tutti i progetti",
        "documents_plan": "Documenti planimetria",
        "documents_plan_explainer": "I documenti aggiunti alla cartella documenti di {unit_name} con la categoria \"Planimetria\" vengono aggiunti automaticamente a questa decisione e sono accessibili a tutti i partner. ",
        "editDocument": "Modifica documento",
        "editDocumentName": "Modifica nome del documento",
        "editDocumentNameSubtitle": "Inserisca un nuovo nome per il documento.",
        "fileTooLargeForPreview": "Il file è troppo grande per l'anteprima. Provi invece a scaricarlo.",
        "files": "File {level_name}",
        "files_count": "Nessun file | 1 file | {count} file",
        "filter": "Filtro",
        "folders": "Cartelle",
        "goToUnitDocumentsFolder": "Vai alla cartella documenti di {unit_name}",
        "goToUnitsFolder": "Questa pagina contiene solo i documenti della decisione. Vada alla cartella dell'unità per vedere gli altri documenti.",
        "include_original_documents": "Mostra i documenti da firmare",
        "includesProposalAndDocuments": "Include i documenti della proposta e i documenti della decisione",
        "info": "I documenti relativi alla Sua casa saranno presto disponibili qui.",
        "lockedDocumentApprovedProposal": "Questo documento appartiene a una proposta approvata e non può essere eliminato",
        "lockedDocumentDelete": "Questo documento non può essere eliminato",
        "lockedDocumentOtherLevel": "Questo documento appartiene a {level} e può essere eliminato solo dai documenti di {level}",
        "lockedDocumentShareLevel": "Questo documento appartiene a {level} e non può essere condiviso con i partner del progetto",
        "locked_parent_level": "Questo documento è gestito a un livello superiore e può essere modificato o eliminato solo lì",
        "locked_template": "Questo documento è stato creato da un modello e non può essere modificato o eliminato",
        "lot": "lotto",
        "more_info": "Maggiori informazioni",
        "name_asc": "Nome A->Z",
        "name_desc": "Nome Z->A",
        "name_lower_asc": "Nome A->Z",
        "name_lower_desc": "Nome Z->A",
        "new": "Nuovo",
        "next": "Avanti",
        "noCustomer": "Nessun cliente ancora assegnato",
        "noPreviewPossible": "Anteprima non disponibile per questo tipo di documento. Provi prima a scaricarlo.",
        "noResults": "Nessun risultato",
        "no_plan_documents": "Nessun documento di planimetria aggiunto alla cartella dell'unità",
        "onlyUnitDocumentsSharedWithProjectPartners": "Solo i documenti dell'unità possono essere condivisi con i partner del progetto",
        "original_documents": "Documenti originali",
        "original_documents_info": "Mostra le versioni originali non firmate dei documenti firmati o da firmare.",
        "owner": "Proprietario",
        "page": "Pagina",
        "phase": "fase",
        "previous": "Indietro",
        "project": "progetto",
        "project_partners": "Partner del progetto",
        "proposal": "proposta",
        "searchName": "Cerca per nome",
        "search_document": "Cerca documento",
        "selected": "{count} documento selezionato | {count} documenti selezionati",
        "selected_count": "{selected} documento selezionato | {selected} documenti selezionati",
        "shareWith": "Condividi con",
        "sharedWithClient": "Condiviso con {client_name}",
        "sharedWithProjectPartners": "Condiviso con i partner del progetto",
        "shared_with": "Condiviso con",
        "shared_with_partners": "Condiviso con i partner",
        "sharingSettingsDecision": "All'interno di questa decisione",
        "sharingSettingsProject": "In questo progetto",
        "showDocumentsFor": "Mostra documenti per",
        "showLevel": "Questo è un documento di {level}",
        "signature": "Firma",
        "signed": "Firmato",
        "signedBy": "Firmato da",
        "source": "Origine",
        "subtitleSharingDocuments": "Il documento selezionato sarà disponibile per i partner del progetto | I documenti selezionati saranno disponibili per i partner del progetto",
        "subtitleUnsharingDocuments": "Il documento selezionato non sarà più disponibile per i partner del progetto | I documenti selezionati non saranno più disponibili per i partner del progetto",
        "ticket": "conversazione",
        "total_selected": "Tutti i {total} documenti selezionati",
        "unit": "unità",
        "unitFolder": "Vai ai documenti dell'unità",
        "updated_at_asc": "Aggiornati meno di recente",
        "updated_at_desc": "Aggiornati di recente",
        "upload_failed": "Il caricamento di uno o più file non è riuscito. Li rimuova o provi a ricaricarli.",
        "uploadedBy": "Caricato da",
        "visibleFor": "Condiviso con",
        "warningNotShared": "Attenzione. Nessuno è stato selezionato. È sicuro? Faccia clic di nuovo per confermare."
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Riceverà una notifica via email quando sarà disponibile un nuovo documento. Li visualizzi e li scarichi qui.",
            "title": "Qui troverà tutti i Suoi documenti"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Il caricamento dei documenti notificherà automaticamente via email tutti i clienti collegati.",
            "title": "Nessun documento per {level_name}"
          }
        },
        "partners": {
          "navigate": {
            "subtitle": "Navighi nella struttura del progetto per vedere i documenti di un'unità",
            "title": "Vada a un'unità per vedere i documenti"
          },
          "new": {
            "subtitle": "Il caricamento dei documenti notificherà automaticamente via email tutti i clienti collegati.",
            "title": "Nessun documento per questa decisione"
          },
          "none": {
            "subtitle": "Qui troverà i documenti per {unit}",
            "title": "Nessun documento ancora"
          }
        }
      },
      "toasts": {
        "bulk_delete": "Documento eliminato con successo | Documenti eliminati con successo",
        "bulk_upload": "Documento caricato con successo | Documenti caricati con successo",
        "update": "{count} documento aggiornato con successo | {count} documenti aggiornati con successo",
        "upload_success": "{count} documento caricato con successo | {count} documenti caricati con successo"
      },
      "upload": {
        "activeUpload": "Caricamento di {count} file in corso | Caricamento di {count} file in corso",
        "clear": "Svuota",
        "complete": "Caricamento completato",
        "navigationWarning": {
          "continue": "Esci comunque",
          "header": "Caricamento in corso",
          "message": "Ci sono file in fase di caricamento. Se esce da questa pagina, il caricamento verrà annullato e non sarà creato alcun documento."
        },
        "uploadFailed": "Caricamento non riuscito"
      },
      "validation": {
        "need_category": "Categoria obbligatoria",
        "need_category_all": "Tutti i documenti devono avere una categoria",
        "selectDocument": "Selezioni almeno 1 documento"
      }
    }
  }
}
